import {
	GET_EXTRACT_JOB_DETAILS_REQUEST,
	GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS,
	GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED,
	GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR,
	GET_BIFROST_JOB_DETAILS_REQUEST,
	GET_BIFROST_JOB_DETAILS_REQUEST_SUCCESS,
	GET_BIFROST_JOB_DETAILS_REQUEST_FAILED,
	GET_BIFROST_JOB_DETAILS_REQUEST_RESET,
} from "../types"

const initialState = {
	isLoading: false,
	extractJobDetails: {},
	bifrostJobDetails: {},
}
const bifrostExtractJobDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_EXTRACT_JOB_DETAILS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				extractJobDetails: action.payload,
			}
		case GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
				extractJobDetails: {},
			}
		case GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR:
			return initialState
		case GET_BIFROST_JOB_DETAILS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_BIFROST_JOB_DETAILS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				bifrostJobDetails: action.payload,
			}
		case GET_BIFROST_JOB_DETAILS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
				bifrostJobDetails: {},
			}
		case GET_BIFROST_JOB_DETAILS_REQUEST_RESET:
			return initialState
		default:
			return state
	}
}

export default bifrostExtractJobDetailsReducer
